import logoUSDT from "../../../Assets/Images/Logos/usdt.png";
import "./PagarFacturas.css";
import TextInput from "../../../components/TextInput/TextField";
import { useState, useRef, useEffect } from "react";
import Common from "../../../components/js/Common";
import PeticionModel from "../../../model/PeticionModel"
import img1 from "../../../Assets/Images/qr/qrms.png"
import { useUser } from "../../../context/UserContext";
import MensajeAlerta from "../../../components/AlertMsg/MensajeAlerta";
import { Historial as HistorialTable } from "../../../components/tablas/Historial";
import { ItemPagoFactura } from "../../../components/tablas/items/ItemPagoFactura";
import InputNip from "../../../components/NipModal/InputNip";

const PagarFacturas = () => {
    const [state, setState] = useState({
        code: '',
        seleccionado: 1,
        visibleModal: false,
        starterPack: ''
    })

    const alertRef = useRef(null)
    const nipRef = useRef(null)
    const { userData, isLoading } = useUser()
    const [propietario, setPropietario] = useState([])
    const [peticion, setPeticion] = useState([])
    const [historial, setHistorial] = useState(null)

    const changeState = (name, value) => {
        setState(prev => ({
            ...prev,
            [name]: value
        }))
    }

    // Función auxiliar para verificar permisos de forma segura
    const verificarPermiso = (nombrePermiso) => {
        if (!userData || !userData.permisos || typeof userData.permisos !== 'object') {
            return false;
        }
        return userData.permisos[nombrePermiso] || false;
    }

    const encontrarFactura = async () => {
        if (!validacion()) return

        const peticionRepo = new PeticionModel()
        const userRepo = new Common()

        try {
            const peticion = await peticionRepo.getFactura(state.code)
            if (peticion) {
                const starterPack = userRepo.determinarPaquete(Number(peticion.monto))
                changeState('starterPack', starterPack)
                setPeticion(peticion)
                const propietarioData = await userRepo.fetchUserDataByName(peticion.email)
                setPropietario(propietarioData)
                changeState('visibleModal', true)
            } else {
                alertRef.current.showAlert("invoice cannot be found", false)
            }
        } catch (error) {
            alertRef.current.showAlert("invoice cannot be found", false)
            console.log(error)
        }
    }

    const pagarFactura = async () => {
        const wallet = state.seleccionado == 1 ? userData.walletDiv : (state.seleccionado == 2 ? userData.walletCom : userData.creditoCorpo)

        if (!validacion(wallet)) return

        // Determinar el porcentaje a pagar basado en permisos
        const puedePageCompleto = verificarPermiso('pagarConCredito')
        const porcentajePago = puedePageCompleto ? 1.0 : 0.5
        const montoPagar = peticion.monto * porcentajePago

        if (state.seleccionado == 1) {
            userData.walletDiv -= montoPagar
        } else if (state.seleccionado == 2) {
            userData.walletCom -= montoPagar
        } else {
            userData.creditoCorpo -= montoPagar
        }

        const userRepo = new Common()
        const peticionRepo = new PeticionModel("Bill payment by transfer", montoPagar, "")
        try {
            peticionRepo.save()
            peticionRepo.borrar(peticion.firebaseKey)
            const fechaHora = userRepo.obtenerFechaHoraActual()
            const historiModel = {
                userName: userData.userName,
                emisor: propietario.userName,
                monto: montoPagar,
                montoMax: peticion.monto,
                date: fechaHora.date,
                hora: fechaHora.hora,
                paquete: state.starterPack,
                wallet: state.seleccionado,
                concepto: 'Payment with invoice',
                pagoCompleto: puedePageCompleto,
                porcentajePago: Math.round(porcentajePago * 100)
            }
            await userRepo.saveHistory(historiModel)
            userRepo.editAnyUser(userData)
            changeState('isLoading', 3)
            changeState('code', '')
        } catch (error) {
            alertRef.current.showAlert("Error to paid", false)
            console.log(error)
        }

    }

    const validacion = (wallet) => {
        const errores = {
            codeNotFound: "Code not found",
            insufficientBalance: "You do not have enough balance to withdraw this amount",
            minBalanceAfterWithdraw: "After withdrawing you need to have at least 25 USDT remaining",
            permisoBloqueado: "You do not have permissions to perform this action",
        }
        const mostrarError = (mensaje) => {
            alertRef.current.showAlert(mensaje, false)
            return false;
        };

        // Determinar el porcentaje a pagar basado en permisos
        const puedePageCompleto = verificarPermiso('pagarConCredito')
        const porcentajePago = puedePageCompleto ? 1.0 : 0.5
        const montoPagar = peticion.monto * porcentajePago

        if (state.code == "" || !state.code) {
            return mostrarError(errores.codeNotFound)
        }
        if (wallet <= 0) {
            return mostrarError(errores.insufficientBalance)
        }
        if (wallet < montoPagar) {
            return mostrarError(errores.insufficientBalance)
        }
        if (state.seleccionado == 1 && Number(wallet - montoPagar) < 25) {
            return mostrarError(errores.minBalanceAfterWithdraw)
        }
        if (state.seleccionado == 1 && !verificarPermiso('permitirPagarDiv')) {
            return mostrarError(errores.permisoBloqueado)
        }
        return true
    }

    const changeSeleccion = (opc) => {
        changeState('seleccionado', Number(opc))
    }

    const handleCopy = () => {
        const inputElement = document.getElementById("wallet");
        inputElement.select();
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        alertRef.current.showAlert("Address copied successfully", true)
        console.log(alertRef.current.showAlert("Address copied successfully", true))
    };

    const fetchHisotrial = async () => {
        const userRepo = new Common()
        const historialData = await userRepo.fetchHistoryByConcept('Payment with invoice',userData.userName)
        setHistorial(historialData.reverse())
    }

    return (
        <section className="PagarFacturas contenido">
            <MensajeAlerta ref={alertRef} />
            <InputNip ref={nipRef} proceso={pagarFactura} />
            {state.visibleModal && (
                confirmarTransaccionModal()
            )}
            <section className="titulos titulo-pf">
                <i class="bi bi-receipt"></i>
                <span>Facturas</span>
            </section>
            {isLoading ? (
                <div className="spinner"></div>
            ) : (
                <>
                    <section className="contenido-pf">
                        <section className="transaccion-area-pf">
                            <section className="inputArea">
                                <p className="titulo">Select your wallet</p>
                                
                                {/* Información del permiso de pago completo */}
                                <div className="payment-permissions-info" style={{
                                    backgroundColor: verificarPermiso('pagarConCredito') ? '#d4edda' : '#fff3cd',
                                    border: `1px solid ${verificarPermiso('pagarConCredito') ? '#c3e6cb' : '#ffeaa7'}`,
                                    borderRadius: '8px',
                                    padding: '12px',
                                    marginBottom: '15px'
                                }}>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                        <i className={`bi ${verificarPermiso('pagarConCredito') ? 'bi-check-circle-fill' : 'bi-info-circle-fill'}`} 
                                           style={{color: verificarPermiso('pagarConCredito') ? '#28a745' : '#ffc107'}}></i>
                                        <strong>Payment Status:</strong>
                                    </div>
                                    <p style={{margin: '5px 0 0 0', fontSize: '0.9em'}}>
                                        {verificarPermiso('pagarConCredito')
                                            ? "✅ You can pay 100% of invoices with your available balance!"
                                            : "⚠️ You can pay up to 50% of invoices. The remaining 50% must be paid externally."
                                        }
                                    </p>
                                </div>

                                <div className="wallets">
                                    {WalletOpcion("Dividend wallet", userData.walletDiv, 1)}
                                    {WalletOpcion("Comission wallet", userData.walletCom, 2)}
                                    {userData.creditoCorpo > 0 && (
                                        WalletOpcion("Corporate credit", userData.creditoCorpo, 3)
                                    )}
                                </div>
                                <TextInput ti={"Billing code"} value={state.code} name={'code'} changeState={changeState} pl={'Code here'} />
                                <button className="boton4" onClick={(e) => encontrarFactura()}><span>Find invoice</span></button>
                            </section>
                            <section className="notas-pf">
                                {verificarPermiso('pagarConCredito') ? (
                                    <>
                                        <p className="titulo">Complete Payment Available!</p>
                                        <h4 className="textoM">With your current permissions, you can pay 100% of any invoice using your selected wallet balance. No external payment required!</h4>
                                        <div style={{
                                            backgroundColor: '#d4edda',
                                            border: '1px solid #c3e6cb',
                                            borderRadius: '8px',
                                            padding: '15px',
                                            marginTop: '15px'
                                        }}>
                                            <h4 style={{color: '#155724', margin: '0 0 10px 0'}}>
                                                <i className="bi bi-check-circle-fill"></i> Full Payment Benefits:
                                            </h4>
                                            <ul style={{color: '#155724', margin: '0', paddingLeft: '20px'}}>
                                                <li>Pay invoices completely from your wallet</li>
                                                <li>No need for external transfers</li>
                                                <li>Instant completion of payments</li>
                                                <li>Simplified payment process</li>
                                            </ul>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <p className="titulo">How to pay the remaining 50%?</p>
                                        <h4 className="textoM">Scan the QR code to pay or copy the wallet address into your preferred application.</h4>
                                        <div className="copyAddrs">
                                            <h4 >Wallet address:</h4>
                                            <div className="wallet">
                                                <input type="text" id="wallet" readOnly value="TMuMJUSBamBf1d2vhbd4g1p13pUf6N7TtM" />
                                                <button onClick={handleCopy} ><i class="bi bi-copy"></i></button>
                                            </div>
                                            <div className="or">
                                                <div className="line" />
                                                <h4>Or</h4>
                                                <div className="line" />
                                            </div>
                                            <div className="qr">
                                                <h4>Qr code:</h4>
                                                <img src={img1} alt="QR code" />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </section>
                        </section>

                        <HistorialTable historial={historial} fetchHistory={fetchHisotrial}>
                            {(item) => (
                                <tr>
                                    <ItemPagoFactura item={item} />
                                </tr>
                            )}
                        </HistorialTable>

                    </section>
                </>
            )
            }
        </section >


    )

    function WalletOpcion(titulo, wallet, opc) {
        return (
            <div onClick={() => changeSeleccion(opc)} className={state.seleccionado == opc ? "seleccionado walletOpcion" : "walletOpcion"}>
                <h3>{titulo}</h3>
                <div>
                    <img src={logoUSDT} alt="usdt_logo" />
                    <span>{(wallet || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',', '.')}</span>
                </div>
            </div>
        )
    }

    function confirmarTransaccionModal() {

        const openNipModal = () => {
            nipRef?.current?.show()
            changeState('visibleModal', false)
        }

        // Determinar el porcentaje a pagar basado en permisos
        const puedePageCompleto = verificarPermiso('pagarConCredito')
        const porcentajePago = puedePageCompleto ? 1.0 : 0.5
        const montoPagar = peticion.monto * porcentajePago

        return (
            <section className="confirmarTransaccionModal">
                <div className="overlay"></div>
                <section className="confirmarTransaccion-contenido">
                    <header>
                        <h1>Transaction details</h1>
                        <button onClick={() => changeState('visibleModal', false)}><i class="bi bi-x"></i></button>
                    </header>
                    <div className=" ">
                        <div className="titulo"><i class="bi bi-person"></i><span>Recipient user</span></div>
                        <h5>Username: <span>{propietario.userName}</span></h5>
                        <h5>Name: <span>{propietario.firstName}</span></h5>
                        <h5>Last name: <span>{propietario.lastName}</span></h5>
                        <h5>email: <span>{propietario.email}</span></h5>
                    </div>
                    <div className="datosDeTranferencia">
                        <div className="titulo"><i class="bi bi-coin"></i><span>Invoice details</span></div>
                        <h5>Selected wallet: <span>{state.seleccionado == 1 ? ("Dividend") : state.seleccionado == 2 ? ("Commision") : ('Corporate credit')}</span></h5>
                        <h5>Starter pack: <span>{state.starterPack}</span></h5>
                        
                        {/* Información del permiso de pago completo */}
                        {puedePageCompleto && (
                            <div className="full-payment-info">
                                <h5 style={{color: '#28a745', fontWeight: 'bold'}}>
                                    <i className="bi bi-check-circle"></i> 
                                    <span> You can pay 100% of this invoice!</span>
                                </h5>
                            </div>
                        )}
                        
                        <h5>Invoice total: <span>{(peticion.monto).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',', '.') || "0.00"} USDT</span></h5>
                        <h5>Payment percentage: <span style={{color: puedePageCompleto ? '#28a745' : '#ffc107', fontWeight: 'bold'}}>{Math.round(porcentajePago * 100)}%</span></h5>
                        <h5>Amount to pay: <span style={{fontSize: '1.2em', fontWeight: 'bold', color: '#007bff'}}>{(montoPagar).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',', '.') || "0.00"} USDT</span></h5>
                        
                        {!puedePageCompleto && (
                            <div className="payment-note">
                                <small style={{color: '#6c757d', fontStyle: 'italic'}}>
                                    <i className="bi bi-info-circle"></i> 
                                    You'll pay 50% now. The remaining 50% must be paid externally.
                                </small>
                            </div>
                        )}
                        
                        <button onClick={openNipModal}><i class="bi bi-send"></i>Pay {Math.round(porcentajePago * 100)}%</button>
                    </div>
                </section>
            </section>
        )
    }
}



export default PagarFacturas